<div class="services-contact-info">
    <h3>Contact Info</h3>

    <ul>
        <li>
            <div class="icon">
                <i class='bx bx-user-pin'></i>
            </div>
            <span>Phone:</span>
            <a href="tel:{{env.phone}}">{{env.phone}}</a>
        </li>
        <li>
            <div class="icon">
                <i class='bx bx-map'></i>
            </div>
            <span>Location:</span>
            {{env.location}}
        </li>
        <li>
            <div class="icon">
                <i class='bx bx-envelope'></i>
            </div>
            <span>Email:</span>
            <a href="mailto:{{env.email}}">{{env.email}}</a>
        </li>
    </ul>
</div>